import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { createTextMask } from 'redux-form-input-masks';

import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';

import validate from '../validate';

const renderTextField = ({
  input,
  label,
  meta: { touched, error },
  ...custom
}) => (
  <TextField
    hintText={label}
    floatingLabelText={label}
    errorText={touched && error}
    {...input}
    {...custom}
    autoComplete="off"
  >
  </TextField>
)

const phoneMask = createTextMask({
  pattern: '(999) 999-99-99',
});

class BuyStep extends Component {

  calcPriceTicket() {
    const { basket } = this.props;

    return basket.reduce((prev, cur) => prev += cur.price, 0);
  }

  render() {
    const { handleSubmit, formValues } = this.props;

    formValues.isReserv = false;

    return (
      <form onSubmit={handleSubmit} className={"first-page"}>
        <div>
          <Field name="fullName" component={renderTextField} label="П.І.П." />
        </div>
        <div>
          <Field
            name="phone"
            component={renderTextField} 
            type="tel"
            label="Номер телефону"
            {...phoneMask}
          />
        </div>
        <div>
          <Field name="email" component={renderTextField} label="Пошта" />
        </div>

        <RaisedButton
          label={`Оплатити ${this.calcPriceTicket()} грн.`}
          disableFocusRipple={true}
          primary={true}
          onClick={handleSubmit}
          style={{marginRight: 12}}
        />
      </form>
    );
  }

};

BuyStep.propTypes = {
  handleSubmit: PropTypes.func,
  formValues: PropTypes.object
};

const mapStateToProps = state => {
  return {
    basket: state.basket,
    formValues: state.form.stepper.values
  };
};

BuyStep = connect(mapStateToProps)(BuyStep);

export default reduxForm({
  form: 'stepper',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  validate
})(BuyStep)


// WEBPACK FOOTER //
// ./src/components/steps/buy-step.jsx